export const COOKIE_CONSENT_KEY = 'cookie_consent'
export const IS_IRAN_KEY = 'user_i'
